import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenesysCloudPlatformApiService } from '../../common/services/genesys-cloud-platform-api.service';
import { SystemPresence } from '../models/system-presence.model';
import { UserPresence } from '../models/user-presence.model';

@Injectable({
  providedIn: 'root'
})
export class PresenceApiService {
  static readonly PresenceValuesPath = 'api/v2/systempresences';

  constructor(readonly api: GenesysCloudPlatformApiService) {
  }

  getSystemPresences$(): Observable<SystemPresence[]> {
    return this.api.get$<SystemPresence[]>(PresenceApiService.PresenceValuesPath);
  }

  setUserPresence$(userId: string, systemPresenceId: string, message?: string): Observable<UserPresence> {
    const path = PresenceApiService.getPresenceApiPath(userId);
    const body = {
      primary: true,
      presenceDefinition: {
        id: systemPresenceId
      },
      message
    };

    return this.api.patch$<UserPresence>(path, body);
  }

  getUserPresence$(userId: string): Observable<UserPresence> {
    return this.api.get$<UserPresence>(PresenceApiService.getPresenceApiPath(userId));
  }

  private static getPresenceApiPath(userId: string): string {
    return `api/v2/users/${userId}/presences/PURECLOUD`;
  }
}
